import { z } from "zod";
import { listQuerySchema, optionalText, priorityField, quantityField } from "./common.js";
export const shopFloorQueueQuerySchema = listQuerySchema.extend({
    workCenterId: z.string().uuid().optional(),
});
export const operationReportSchema = z.object({
    good: quantityField,
    scrap: z
        .array(z.object({
        quantity: quantityField,
        reasonId: z.string().uuid("Invalid reason id."),
    }))
        .max(20)
        .optional(),
    rework: z
        .array(z.object({
        quantity: quantityField,
        reasonId: z.string().uuid("Invalid reason id."),
    }))
        .max(20)
        .optional(),
    note: optionalText(1000),
});
export const operationIssueSchema = z.object({
    description: z.string().trim().min(1, "A description is required.").max(2000),
    severity: priorityField,
    blocking: z.boolean().default(false),
});
export const operationNoteSchema = z.object({
    note: optionalText(1000),
});
export const operationIdParamSchema = z.object({
    id: z.string().uuid("Invalid operation id."),
});
//# sourceMappingURL=shopFloor.js.map